<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="commissioning-loader">
      <div class="progress-spinner">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      </div>
      <div class="message flex flex-col gap-[12px] justify-center items-center">
        <div class="message-loading" *ngIf="title">{{ title }}</div>
        <div class="message-description" data-at-loader-message>
          {{ message }}
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
